import { useMemo } from 'react';
import Tooltip from '@material-ui/core/Tooltip';
import makeStyles from '@material-ui/core/styles/makeStyles';

import { FormField, FormFileDownload, Option } from '../../types';
import { useGDirection, useGTranslation } from '../../hooks';
import { inputTypeMap } from '../../constants';

interface GridifyItemProps {
	item: FormField<any>;
	selectOptions?: Option[];
	download?: Partial<FormFileDownload>;
}

const GridifyItem: React.FC<GridifyItemProps> = ({ item, selectOptions, download }) => {
	const classes = useStyles();

	const dir = useGDirection();
	const translate = useGTranslation();

	const inputProps = useMemo(() => ({
		id: item.id.toString(),
		description: `${typeof item.description === "string" ? item.description : translate(item.description)}${item.descriptionQuestion ? "?" : ":"}${item.required ? ' *' : ''}`,
		options: item.inputType === 'select' ? selectOptions : undefined,
		download: item.download && download ? { ...download, ...item.download } as FormFileDownload : undefined,
		readOnly: item.readonly ?? undefined
	}), [item, selectOptions, download]);

	const FormComponent = useMemo(() => inputTypeMap[item.inputType ?? 'text'], [item.inputType]);

	if (item.inputType !== 'file' || !item.tooltip || dir !== "ltr") return (
		<FormComponent {...inputProps} />
	);

	return (
		<Tooltip
			title={item.tooltip}
			placement="top-start"
			arrow
			classes={{
				tooltipPlacementTop: classes.tooltip
			}}
		>
			<div>
				<FormComponent {...inputProps} />
			</div>
		</Tooltip>
	);
}

export default GridifyItem;

const useStyles = makeStyles({
	tooltip: {
		marginBottom: 5.5,
	},
});